import { render, staticRenderFns } from "./index.vue?vue&type=template&id=796be206&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=796be206&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796be206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('796be206')) {
      api.createRecord('796be206', component.options)
    } else {
      api.reload('796be206', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=796be206&scoped=true", function () {
      api.rerender('796be206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/alliance/promoter-apply/index.vue"
export default component.exports